<template>
     
     <div class="box">
         <div id="container" ref="spv" style="width:100%"></div>
         <div class="tool">
             <div class="control">
                <div @click="up" class="el-icon-d-arrow-left"></div>
                <div @click="reset" class="el-icon-refresh-left"></div>
                <div @click="play" :class="playTextStatus ? 'el-icon-video-play' : 'el-icon-video-pause' "></div>
                <div @click="down" class="el-icon-d-arrow-right"></div>
                <div >
                    <select name="" id="" v-model="speadCode" @change="change">
                        <option label="x1"  :value="1"></option>
                        <option label="x5" :value="5"></option>
                        <option label="x10" :value="10"></option>
                        <option label="x30" :value="30"></option>
                        <option label="x50" :value="50"></option>
                    </select>
                </div>
             </div>
              <div class="range_box">
                <input class="range" @mousedown="handleMousedown" @mouseup="handleMouseup" type="range" :min="0" step="1" :max="endS" v-model="currentDistance" @change="changeRange">
              </div>
         </div>
        <div class="btn_box" :class="{'right': isShow, 'right_none': !isShow}">
            <div @click="changeBox" class="btn " :class="{'el-icon-s-unfold': isShow, 'el-icon-s-fold': !isShow}"></div>
        </div>
         <div class="aside" :class="{'none': !isShow}">
            <div class="box">
                <el-checkbox @change="changePolygon" v-model="polygonIsShow">显示围栏</el-checkbox>
            </div>
         </div>
     </div>
</template>

<script>
export default {
    data(){
        return {
            api: require('@/api/schoolmanage/location').default,
            teachApi: require('@/api/schoolmanage/teacharea').default,
            isShow: true, // 侧边栏显示与否
            polygonIsShow: false, // 侧边栏显示与否
            pathSimplifierIns: null,
            playTextStatus: true,
            navg: null,
            currentIndex: 0,
            nextTail: 0,
            currentDistance: 0,
            pathLength: 0,
            spead: 30, // 默认速度
            speadCode: 1,
            endS: 0,
            tempStatus: '',
            src: 'data:image/png;base64,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',
            paths: [],
            map: null,
            polygon: [],
        }
    },
    computed: {
   
        step(){
            
            return Math.ceil(this.pathLength / 10);
        }
    },

    methods: {
        getLatlng(){
            this.api.list({
                CarId: 11,
                EndTime: "2022-05-10 23:59:59",
                StartTime: "2022-05-10 00:00:00"
            }).then(res => {
                this.paths = res.Data.map(v => {
                    return [v.Lng,v.Lat]
                })

                this.car_PathSimplifier();
                this.car_SimpleMarker();

            })
        },
        changeBox(){ // 隐藏显示侧边栏
            this.isShow = !this.isShow;
        },
        change(e){
            this.navg.setSpeed(this.spead * Number(this.speadCode))
        },
        changePolygon(e){
            // var aids = [];
            if(!this.polygonIsShow){

                this.polygon.forEach(v => {
                    v.polygon.hide()
                    v.polygon.destroy()
                    v.text.hide()
                    v.text.destroy()
                })

                return

            }
            this.teachApi.list({ Status: 3 }).then(res => {
                if(res.Code==0) {
                    let teachAreaIds = res.Data.map(v => {

                        return v.TeachAreaId
                        // aids.push(e.TeachAreaId)
                    })
                    // this.aids = aids;
                    this.polygon = [];
                    teachAreaIds.forEach(aid => {
                        this.teachApi.info(aid).then(res2 => {
                        if(res2.Code==0) {

                            let paths = res2.Data.Points.map(v => {
                                return [v.Lng, v.Lat]
                            })


                            let polygon = new AMap.Polygon({
                                map: this.map,
                                path: paths,
                                strokeColor: res2.Data.Color || 'rgba(55,119,255)', //线颜色
                                strokeOpacity: 1, //线透明度
                                strokeWeight: 3,    //线宽
                                fillColor: res2.Data.Color || 'rgba(55,119,255)', //填充色
                                fillOpacity: 0.3, //填充透明度
                            })
                            let text = new AMap.Text({
                                position: this.calculateCenter(paths),
                                anchor: 'bottom-center',
                                text: res2.Data.AreaName,
                                style: {
                                    'background-color': 'transparent',
                                    'color': res2.Data.Color || 'rgba(55,119,255)', 
                                    'border': 'none', 
                                    'font-size': '22px',
                                },
                            });
                            this.map.add(text);
                            this.polygon.push({
                                polygon,
                                text
                            })

                            
                        }
                        })
                    })
                }
            })
        },
        //计算区域中心点
        calculateCenter(lnglatarr) {

            let lngs = lnglatarr.map(v => {
                return v[0];
            })

            let Lats = lnglatarr.map(v => {
                return v[1];
            })


            let lngsPath = lngs.sort((a, b) => a - b);
            let LatsPath = Lats.sort((a, b) => a - b);

            let minLng = lngsPath[0];
            let maxLng = lngsPath[lngsPath.length - 1];
            
            let minLat = LatsPath[0];
            let maxLat = LatsPath[lngsPath.length - 1];

            let lngCenter = (minLng + maxLng) / 2;
            let latCenter = (minLat + maxLat) / 2;

            return new AMap.LngLat(lngCenter, latCenter);
        },

        changeRange(){
            
          
           
            if(this.navg.getNaviStatus() === 'pause' || this.navg.getNaviStatus() === 'stop'){
                this.navg.start();
                this.navg.moveByDistance(Number(this.currentDistance));
                this.navg.resume();
                this.navg.pause();
            }else{
                this.navg.start();
                this.navg.moveByDistance(Number(this.currentDistance));
            }
        },
        handleMousedown(){
            this.tempStatus = this.navg.getNaviStatus();
            this.navg.pause();
            this.playTextStatus = true;
        },
        handleMouseup(){
             if(this.tempStatus === 'moving' ){
                this.navg.resume();
                this.playTextStatus = false;
             }
             
        },
        reset(){
            this.navg.start();
            this.playTextStatus = false;
           
        },
        play(){

            if(this.playTextStatus){
                this.navg.resume();
            }else{
                this.navg.pause();

                let {idx, tail} = this.navg.getCursor();
                this.currentIndex = idx;
                this.nextTail = tail;
            }

           
           this.playTextStatus = !this.playTextStatus;


        },
        down(){
            
            this.navg.moveToPoint(this.currentIndex + this.step, 0);
            if(this.navg.getNaviStatus() === 'pause' || this.navg.getNaviStatus() === 'stop'){
                 this.navg.resume();
                 this.navg.pause();
            }
          
         
        //   this.navg.moveByDistance(this.nextTail);     
        },
        up(){
    
            if(this.navg.getNaviStatus() === 'pause' || this.navg.getNaviStatus() === 'stop'){

                if(this.currentIndex - this.step < 0){
                    this.navg.start();
                    this.currentDistance = 0;
                    this.navg.pause();
                }else{
                    let _index = this.currentIndex;
                    this.navg.moveToPoint(this.currentIndex - this.step, 0);
                    let _temp = this.navg.getMovedDistance();
                    this.navg.start();
                    this.currentDistance = _temp;
                    this.navg.moveToPoint(_index - this.step, 0);
                    this.navg.resume();
                    this.navg.pause();
                }
               
            }else{

                if(this.currentIndex - this.step < 0){
                    this.navg.start();
                    this.currentDistance = 0;

                }else{
                    let _index = this.currentIndex;
                    this.navg.moveToPoint(this.currentIndex - this.step, 0);
                    let _temp = this.navg.getMovedDistance();
                    this.navg.start();
                    this.currentDistance = _temp;
                    this.navg.moveToPoint(_index - this.step, 0);
                }

                
            }
        },
        // 创造围栏
        createPolygon(ops, textOps = null, status = false){
            
            var polygon = new AMap.Polygon(ops);

            var text = null
            if(textOps){
                text = new AMap.Text(textOps);
                this.map.add(text);
            }

            if(!status){
                polygon.hide();
                text.hide();
            }

            return {
                polygon, text
            }
        },
        onload() {
            this.pathSimplifierIns.renderLater();
        },
        onerror(e) {
            alert('图片加载失败！');
        },
        car_PathSimplifier(){ // PathSimplifier 模块
         

            let self = this;

            AMapUI.load(['ui/misc/PathSimplifier', 'lib/$'], function(PathSimplifier, $) {
                
                if (!PathSimplifier.supportCanvas) {
                    alert('当前环境不支持 Canvas！');
                    return;
                }
                
                
                self.pathSimplifierIns = new PathSimplifier({
                    zIndex: 100,
                    //autoSetFitView:false,
                    map: self.map, //所属的地图实例

                    getPath: function(pathData, pathIndex) {
                        return pathData.path;
                    },
                    getHoverTitle: function(pathData, pathIndex, pointIndex) {

                        return null;
                    },
                    renderOptions: {

                        pathLineStyle: {
                            lineWidth: 4,
                            strokeStyle: "skyblue",
                            borderWidth: 1,
                            borderStyle: "#ffffff",
                            dirArrowStyle: false
                        },
                        pathLineHoverStyle: {
                            lineWidth: 4,
                            strokeStyle: "skyblue",
                            borderWidth: 1,
                            borderStyle: "ffffff",
                            dirArrowStyle: false
                        },
                        pathLineSelectedStyle: {
                            lineWidth: 4,
                            strokeStyle: "skyblue",
                            borderWidth: 1,
                            borderStyle: "#ffffff",
                            dirArrowStyle: false
                        },
                        startPointStyle: {
                            radius: 6,
                            fillStyle: "skyblue",
                            lineWidth: 1,
                            strokeStyle: "#eeeeee"
                        },
                        endPointStyle: {
                            radius: 6,
                            fillStyle: "skyblue",
                            lineWidth: 1,
                            strokeStyle: "#eeeeee"
                        },
                        keyPointStyle: {
                            radius: 3,
                            strokeStyle: "skyblue",
                            borderWidth: 1,
                            borderStyle: "#ffffff",
                            dirArrowStyle: false
                        },
                        keyPointHoverStyle: {
                            radius: 3,
                            strokeStyle: "skyblue",
                            borderWidth: 1,
                            borderStyle: "#ffffff",
                            dirArrowStyle: false
                        },
                        keyPointOnSelectedPathLineStyle: {
                            radius: 3,
                            strokeStyle: "skyblue",
                            borderWidth: 1,
                            borderStyle: "#ffffff",
                            dirArrowStyle: false
                        }
                    }
                });

                

                self.pathSimplifierIns.setData([{
                    name: '路线0',
                    path: self.paths,
                }]);

                // //对第一条线路（即索引 0）创建一个巡航器
                self.navg = self.pathSimplifierIns.createPathNavigator(0, {
                    loop: false, //循环播放
                    speed: self.spead, //巡航速度，单位千米/小时
                    pathNavigatorStyle: {
                        width: 48,
                        height: 48,
                        content: PathSimplifier.Render.Canvas.getImageContent(self.src, self.onload,  self.onerror),
                        pathLinePassedStyle: {
                            lineWidth: 4,
                            strokeStyle: "#dcd5d5",
                            borderWidth: 1,
                            borderStyle: "#ffffff",
                            dirArrowStyle: false
                        }
                    }
                });

                let status = false

                self.navg.on('move', (e)=>{
                    if(!status){
                        return
                    }
                    let {idx} = self.navg.getCursor();
                    self.currentIndex = idx;
                    self.currentDistance = self.navg.getMovedDistance();
                })

                self.pathLength = self.navg.getPathEndIdx() + 1;

                // 获取最后节点与初始节点的距离
                self.navg.moveToPoint(self.navg.getPathEndIdx(),0);
                self.endS = self.navg.getMovedDistance();
                self.navg.start();
                self.navg.pause();
                self.navg.moveToPoint(0,0);
                status = true;

            });
            },
        car_SimpleMarker(){
            let self = this
            AMapUI.loadUI(['overlay/SimpleMarker'], function(SimpleMarker) {
                let endPoint = self.paths[self.paths.length - 1];
                let startPoint = self.paths[0];
                 console.log('startPoint, endPoint', startPoint, endPoint)
              
                //启动页面
               new SimpleMarker({
                    //前景文字
                     iconLabel: {
                        innerHTML: '<i>终</i>', //设置文字内容
                        style: {
                            color: '#fff' //设置文字颜色
                        }
                    },

                    //图标主题
                    iconTheme: 'fresh',
                    //背景图标样式
                    iconStyle: 'red',
                    //...其他Marker选项...，不包括content
                    map: self.map,
                    position: endPoint
                });


                new SimpleMarker({
                    //前景文字
                     iconLabel: {
                        innerHTML: '<i>起</i>', //设置文字内容
                        style: {
                            color: '#fff' //设置文字颜色
                        }
                    },

                    //图标主题
                    iconTheme: 'fresh',
                    //背景图标样式
                    iconStyle: 'green',
                    //...其他Marker选项...，不包括content
                    map: self.map,
                    position: startPoint
                });
            });
        },

    },
    mounted(){


        this.map = new AMap.Map('container', {
            viewMode: '2D', // 默认使用 2D 模式，如果希望使用带有俯仰角的 3D 模式，请设置 viewMode: '3D',
            zoom:16, //初始化地图层级
            center: [116.708463, 23.37102] //初始化地图中心点
        });


        // this.getLatlng();


        var marker = new AMap.Marker({
            position: new AMap.LngLat(116.708463, 23.37102),
            icon: new AMap.Icon({            
                image: this.src,
                size: new AMap.Size(56, 56),  //图标所处区域大小
                imageSize: new AMap.Size(56,56) //图标大小
            }), 

            anchor: 'bottom-center',
            angle: 36,
            label: {
                content: '粤D0001',
                direction: 'bottom',
            },
        });
     
        marker.on('click', ()=> {
            console.log('111')
        })
        this.map.add(marker);
   

    }
}
</script>

<style lang="scss" scoped>
  .box{
      width: 100%;
      height: 800px;
      position: relative;
      display: flex;
      flex-direction: column;
      align-items: center;

      #container{
        height: 100%;
        width: 100%;
      }

      .tool{
          height: 80px;
          width: 300px;
          background-color: #fff;
          position: absolute;
          bottom: 0;
          display: flex;
          flex-direction: column;
          z-index: 10000;

          .control{
              height: 60px;
              width: 300px;
              display: flex;
              div{
                width: 60px;
                height: 60px;

                font-size: 36px;

                flex: 1;
                display: flex;
                justify-content: center;
                align-items: center;
            }
          }

          .range_box{
              height: 20px;
              width: 300px;

              .range{
                  width: 100%;
              }
          }
      }
       .btn_box{
        position: absolute;
          top: 0;
          bottom: 0;
          width: 30px;
          display: flex;
          align-items: center;

            .btn{
                width: 30px;
                height: 60px;
                display: flex;
                justify-content: center;
                align-items: center;
                background-color: #fff;
                cursor: pointer;
            }
        }
      .aside{
          position: absolute;
          right: 0;
          top: 0;
          bottom: 0;
          width: 250px;
          display: flex;
          background-color: #fff;
          
          .box{
              width: 100%;
              height: 40px;
              margin: 18px;
          }
          
      }

      .none{
              display: none;
          }
        .right{
            right: 250px;
        }
        .right_none{
            right: 0;
        }
       
  }
 ::v-deep .amap-marker-label {
    position: absolute;
    z-index: 2;
    white-space: nowrap;
    cursor: default;
    padding: 3px;
    font-size: 16px;
    line-height: 14px;
    border: none;
    background-color: transparent;
    
}

</style>

<style lang="scss" >

</style>